module.exports = __webpack_public_path__ + "static/media/297907.e4f53cb4.png";